var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-offset-3 col-lg-6"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('legend', [_vm._v("Login")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.username),
      expression: "form.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.form.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-3 control-label",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-9 col-lg-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.login($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Don't have an account?")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": "/home"
    }
  }, [_vm._v("Cancel")])], 1)])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a0ff51","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 81
// module chunks = 0